export var TITLE = 'Wenxin';
export var TEXT_MULTIPLE = 0.75;
export var SPACE_MULTIPLE = 0.2;
export var COLOR_PRIMARY = '#167ADF';
export var COLOR_GRADIENT = 'linear-gradient(to right, #0A51C3,  #23A4FB)';